import { render, staticRenderFns } from "./VvtList.vue?vue&type=template&id=715f194a&"
import script from "./VvtList.vue?vue&type=script&lang=js&"
export * from "./VvtList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports